export default "__VITE_ASSET__BrEoCs1z__"